// extracted by mini-css-extract-plugin
export var accordionList__item = "AccordionList-module--accordion-list__item--f9deb";
export var accordionList__itemActive = "AccordionList-module--accordion-list__item--active--f750d";
export var accordionList__itemContent = "AccordionList-module--accordion-list__item-content--dd720";
export var accordionList__itemLabel = "AccordionList-module--accordion-list__item-label--04b01";